import { makeStyles } from '@material-ui/core/styles';
import colors from '../../styles/colors';

export const useStyles = makeStyles((theme) => ({
  listItemIcon: {
    minWidth: 35,
    color: theme.colors.blue,
  },
  title: {
    borderBottom: `1px solid ${colors.black}`,
    padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
    flexDirection: 'row',
    alignItems: 'center',
    display: 'flex',
  },
  popper: {
    zIndex: 100000,
    backgroundColor: theme.palette.background.paper,
    boxShadow: '2px 2px 4px rgba(0,0,0,0.5)',
  },
}));
